import createEmailTracker from '@/mixin/createEmailTracker'
import updateEmailStatus from '@/mixin/updateEmailStatus'
import {get} from 'lodash'
import createBodyMessage from '@/mixin/createBodyMessage'

export default {
  mixins: [createEmailTracker, updateEmailStatus, createBodyMessage],
  methods: {
    sendMessage ({mail, threadId, loader, userId, callback, index, trackerId, replyTo}) {
      const boundary = 'foo_bar_baz'
      const body = this.createBodyMessage({mail, threadId, boundary})
      const options = {
        path: `https://www.googleapis.com/upload/gmail/v1/users/${userId}/messages/send?uploadType=multipart`,
        method: 'POST',
        headers: {
          'Content-Type': `multipart/related; boundary="${boundary}"`
        },
        body: body
      }
      this.$gapi.request(options)
        .then(resp => {
          if (replyTo) this.updateEmailStatus({messageId: replyTo, status: 2})
          this.updateEmailTracker({
            messageId: get(resp, 'result.id', ''),
            threadId: get(resp, 'result.threadId', ''),
            userMail: userId,
            trackerId
          })
          loader = false
          callback(resp, index)
        })
        .catch(err => {
          console.error(err)
          loader = false
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/sendMessage.js